import loadIntegrationAsset from '../helpers/loadIntegrationAsset';
import useAsset from './useAsset';

export default function useIntegrationAsset(assetName: string) {
    return useAsset(loadIntegrationAsset, assetName);
}
